import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AdelantoForm } from '../../components/AdelantoForm.js';
import { Button } from '../../components/ui/Button.js';
import { Card, CardBody, CardHeader, CardTitle } from '../../components/ui/Card.js';
import { FwaApiError } from '../../lib/api.js';
import { useCreateAdelanto } from '../../lib/queries/adelantos.js';

export function AdelantosNew() {
  const navigate = useNavigate();
  const mutation = useCreateAdelanto();
  const [serverError, setServerError] = useState<string>('');

  return (
    <div className="space-y-4 max-w-2xl">
      <h1 className="text-2xl font-semibold text-gray-900">Nuevo adelanto</h1>

      <Card>
        <CardHeader>
          <CardTitle>Datos del adelanto</CardTitle>
        </CardHeader>
        <CardBody>
          <AdelantoForm
            mode="create"
            onSubmit={(payload) => {
              setServerError('');
              mutation.mutate(payload, {
                onSuccess: (res) => {
                  if ('queuedOffline' in res) {
                    navigate('/outbox');
                    return;
                  }
                  navigate(`/adelantos/${res.data.entity_id}`);
                },
                onError: (err) => {
                  if (err instanceof FwaApiError) {
                    setServerError(err.problem.detail ?? err.problem.title);
                  } else {
                    setServerError(err.message);
                  }
                },
              });
            }}
            isSubmitting={mutation.isPending}
            serverError={serverError}
          />
        </CardBody>
      </Card>

      <Link to="/adelantos">
        <Button variant="ghost">← Regresar al listado</Button>
      </Link>
    </div>
  );
}
